import { AttachmentType } from '@/enums/attachmentType.enum';
import { Attachment } from '@/interfaces/attachment';
import { AttachmentResource, attachmentResource } from '@/resources/attachment.resource';
import { EntityModule } from '../entity.module';

/**
 * Moduł załączników
 *
 * @export
 * @class AttachmentModule
 * @extends {EntityModule<Attachment, AttachmentResource>}
 */
export class AttachmentModule extends EntityModule<Attachment, AttachmentResource> {
  constructor() {
    super(attachmentResource);
    this.actions = {
      ...this.actions,
      /**
       * Dodaje załącznik
       *
       * @param {*} context
       * @param {Attachment} data
       * @returns {Promise<number>}
       */
      add: (context: any, data: Attachment): Promise<number> => {
        return this.resource
          .add(data)
          .then(id => context.dispatch('get', id))
          .then(attachment => {
            context.commit('add', attachment);
            context.commit('incrementCount');
            return attachment.id;
          });
      },

      /**
       * Aktualizacja załącznika
       *
       * @param {*} context
       * @param {*} data
       * @returns {Promise<number>}
       */
      updateEditedHtmlAttachment: (context: any, data: any): Promise<number> => {
        return this.resource.updateEditedHtmlAttachment(data);
      },

      /**
       * Dodaje załącznik z mdok
       *
       * @param {*} context
       * @param {{
       *           uid: number;
       *           entityId: string;
       *           entityType: string;
       *           attachmentType: AttachmentType;
       *           additionalMetadata?: any;
       *           documentValues?: any;
       *         }} data
       * @returns {Promise<number>}
       */
      attachmentAddFromMdok: (
        context: any,
        data: {
          uid: number;
          entityId: string;
          entityType: string;
          attachmentType: AttachmentType;
          additionalMetadata?: any;
          documentValues?: any;
        }
      ): Promise<number> => {
        return this.resource.attachmentAddFromMdok(data).then(attachment => {
          context.commit('add', attachment);
          context.commit('incrementCount');
          return attachment.id as number;
        });
      },

      /**
       * Generuje ponownie załącznik
       *
       * @param {*} context
       * @param {{id: number}} data
       * @returns {Promise<boolean>}
       */
      generateAgain: (context: any, data: { id: number }): Promise<boolean> => this.resource.generateAgain(data),

      /**
       * Oznacza jako wysłany
       *
       * @param {*} context
       * @param {{id: number}} data
       * @returns {Promise<boolean>}
       */
      markAsSent: (context: any, data: { id: number }): Promise<boolean> => this.resource.markAsSent(data),

      /**
       * Zdejmuje oznaczenie załącznika jako już wysłany
       *
       * @param {*} context
       * @param {{id: number}} data
       * @returns {Promise<boolean>}
       */
      reverseMarkAsSent: (context: any, data: { id: number }): Promise<boolean> => this.resource.reverseMarkAsSent(data)
    };
  }
}

export default new AttachmentModule();
